(() => {
  if (window.lvnAnnouncementInitialized) return;
  window.lvnAnnouncementInitialized = true;
  const states = new WeakMap();
  const fadeClasses = ['announcement-bar-slider--fade-in-next', 'announcement-bar-slider--fade-in-previous', 'announcement-bar-slider--fade-out-next', 'announcement-bar-slider--fade-out-previous'];
  function initialize(root = document) {
    root.querySelectorAll('slideshow-component.announcement-bar').forEach(section => {
      if (states.has(section)) return;
      const slider = section.querySelector('.announcement-bar-slider > .slider');
      const slides = slider ? [...slider.querySelectorAll('.slideshow__slide')] : [];
      if (slides.length < 2) return;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const period = Number(slider.dataset.speed) * 1000;
      let interval, positionTimer, fadeTimer, hovered = false, focused = false, manual = false;
      const offset = () => slides[1].offsetLeft - slides[0].offsetLeft || slider.clientWidth;
      const current = () => offset() > 0 ? Math.max(0, Math.min(slides.length - 1, Math.round(slider.scrollLeft / offset()))) : 0;
      const resetFade = () => slides.forEach(slide => fadeClasses.forEach(name => slide.classList.remove(name)));
      const visibility = () => slides.forEach((slide, index) => {
        const active = index === current();
        slide.setAttribute('aria-hidden', String(!active));
        if (active) slide.removeAttribute('tabindex'); else slide.setAttribute('tabindex', '-1');
        slide.querySelectorAll('a').forEach(link => { if (active) link.removeAttribute('tabindex'); else link.setAttribute('tabindex', '-1'); });
      });
      const move = direction => {
        if (offset() <= 0) return;
        const from = current(), to = (from + direction + slides.length) % slides.length;
        clearTimeout(positionTimer); clearTimeout(fadeTimer); resetFade();
        if (!motion.matches) {
          const name = direction > 0 && from !== slides.length - 1 || direction < 0 && from === 0 ? 'next' : 'previous';
          slides[from].classList.add('announcement-bar-slider--fade-out-' + name);
          slides[to].classList.add('announcement-bar-slider--fade-in-' + name);
        }
        positionTimer = setTimeout(() => { slider.scrollTo({ left: to * offset() }); visibility(); }, motion.matches ? 0 : 250);
        fadeTimer = setTimeout(resetFade, motion.matches ? 0 : 500);
      };
      const pause = () => { clearInterval(interval); interval = undefined; slider.setAttribute('aria-live', 'polite'); };
      const update = () => {
        pause();
        if (slider.dataset.autoplay !== 'true' || !Number.isFinite(period) || period <= 0 || motion.matches || hovered || focused || manual) return;
        slider.setAttribute('aria-live', 'off');
        interval = setInterval(() => move(1), period);
      };
      const enter = () => { hovered = true; update(); };
      const leave = () => { hovered = false; update(); };
      const focusIn = () => { focused = true; update(); };
      const focusOut = event => { focused = section.contains(event.relatedTarget); update(); };
      const click = event => {
        const button = event.target.closest('.slider-button');
        if (!button || !section.contains(button) || !['next', 'previous'].includes(button.name)) return;
        event.preventDefault(); manual = true; update(); move(button.name === 'next' ? 1 : -1);
      };
      section.addEventListener('mouseover', enter);
      section.addEventListener('mouseleave', leave);
      section.addEventListener('focusin', focusIn);
      section.addEventListener('focusout', focusOut);
      section.addEventListener('click', click);
      slider.addEventListener('scroll', visibility);
      motion.addEventListener('change', update);
      states.set(section, () => {
        pause(); clearTimeout(positionTimer); clearTimeout(fadeTimer); resetFade();
        section.removeEventListener('mouseover', enter); section.removeEventListener('mouseleave', leave);
        section.removeEventListener('focusin', focusIn); section.removeEventListener('focusout', focusOut);
        section.removeEventListener('click', click); slider.removeEventListener('scroll', visibility);
        motion.removeEventListener('change', update); states.delete(section);
      });
      visibility(); update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true }); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('slideshow-component.announcement-bar').forEach(section => states.get(section)?.()));
})();
